import {
  type DrawingCanvasLineStyle,
  type DrawingCanvasShape,
  DrawingCanvasShapeType,
  type Point,
  type RGBColor,
} from '../types';
import { defaultLineJoin, defaultLineWidth, defaultStrokeColor, hitRegionBuffer, strokeHighlight } from './common';

const dashPattern = [6, 4];

export const renderLine = (points: Point[], ctx: CanvasRenderingContext2D, style?: DrawingCanvasLineStyle): void => {
  if (points.length < 2) return;
  ctx.lineWidth = style?.lineWidth ?? defaultLineWidth;
  ctx.strokeStyle = style?.strokeColor ?? defaultStrokeColor(ctx);
  ctx.lineJoin = defaultLineJoin;
  if (style?.dashed) ctx.setLineDash(dashPattern);
  ctx.beginPath();
  ctx.moveTo(points[0].x, points[0].y);
  for (let i = 1; i < points.length; i++) {
    ctx.lineTo(points[i].x, points[i].y);
  }
  if (style?.isHighlighted) strokeHighlight(ctx, style);
  ctx.stroke();
  ctx.setLineDash([]);
};

export const renderLineHitRegion = (
  points: Point[],
  ctx: CanvasRenderingContext2D,
  color: RGBColor,
  originalStyle?: DrawingCanvasLineStyle,
): void => {
  if (points.length < 2) return;
  ctx.strokeStyle = color;
  ctx.lineWidth = (originalStyle?.lineWidth ?? defaultLineWidth) + hitRegionBuffer;
  ctx.lineJoin = defaultLineJoin;
  ctx.beginPath();
  ctx.moveTo(points[0].x, points[0].y);
  for (let i = 0; i < points.length; i++) {
    ctx.lineTo(points[i].x, points[i].y);
  }
  ctx.stroke();
};

export const isValidLine = (drawingShape: Pick<DrawingCanvasShape, 'type' | 'points'>): boolean => {
  return drawingShape.type === DrawingCanvasShapeType.LINE && drawingShape.points.length >= 2;
};
